<script>
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      'Binary Graduation': 'Graduação Binária',
      'Current': 'Atual',
      'Total': 'Total',
      'Used': 'Aproveitado',
      'Left': 'Esquerdo',
      'Right': 'Direito',
      'Month accumulated': 'Acumulado do mês',
      'Lower side accumulated': 'Equipe menor acumulada',
      'Points of the day': 'Ponto do dia',
      'Products Vertical': 'Vertical de Produtos',
      'Services Vertical': 'Vertical de Serviços',
      'Active': 'Ativo',
      'Inactive': 'Inativo',
      'Accumulated + active smaller leg': 'Acumulado + equipe menor ativa',
      'Smaller leg': 'Equipe menor',
      'Qualified': 'Qualificado',
      'Not qualified': 'Não qualificado',
    },
    es: {
      'Binary Graduation': 'Graduación Binaria',
      'Current': 'Actual',
      'Total': 'Total',
      'Used': 'Aprovechado',
      'Left': 'Izquierdo',
      'Right': 'Derecho',
      'Month accumulated': 'Acumulado del mes',
      'Lower side accumulated': 'Pierna menor acumulada',
      'Points of the day': 'Punto del día',
      'Products Vertical': 'Vertical de Productos',
      'Services Vertical': 'Vertical de Servicios',
      'Active': 'Activo',
      'Inactive': 'Inactivo',
      'Accumulated + active smaller leg': 'Acumulado + pierna menor activa',
      'Smaller leg': 'Pierna menor',
      'Qualified': 'Calificado',
      'Not qualified': 'No calificado',
    }
  },
  data() {
    return {
      loaded: false,

      month: this.$moment().format('MM/YYYY'),
      day: this.$moment().format('DD/MM/YYYY'),

      binary: {
        current: { left: 0, right: 0 },
        valid: { left: 0, right: 0 },
        lower: 0,
        smaller: 0,
        sum: 0,
        verticals: {
          products: { status: 'inactive', day: { left: 0, right: 0 } },
          services: { status: 'inactive', day: { left: 0, right: 0 } },
        },
      },
    };
  },
  computed: {
    verticalList() {
      return [
        { key: 'products', title: this.t('Products Vertical'), ...this.binary.verticals.products },
        { key: 'services', title: this.t('Services Vertical'), ...this.binary.verticals.services },
      ];
    },
    // Qualificado se qualquer vertical estiver ativa
    isActive() {
      return this.verticalList.some(vertical => vertical.status == 'active');
    },
  },
  methods: {
    // Largura da barra do lado (o maior lado do dia ocupa 100%)
    legPercent(day, side) {
      const max = Math.max(Number(day.left) || 0, Number(day.right) || 0);
      return max > 0 ? ((Number(day[side]) || 0) / max) * 100 : 0;
    },
    getBinary() {
      api
        .get('reports/graduation/binary')
        .then(response => {
          if (response.data.status == 'success') {
            this.binary = response.data.binary;
            this.loaded = true;
          }
        });
    },
  },
  created() {
    this.getBinary();
  },
};
</script>

<template>
  <fieldset class="binary" v-if="loaded">
    <legend>
      {{ t('Binary Graduation') }} <sup class="font-weight-light">{{ month }}</sup>
    </legend>

    <header class="binary-head">
      <div class="binary-head-right">
        <span class="binary-badge" :class="{ 'is-active': isActive }">
          {{ isActive ? t('Qualified') : t('Not qualified') }}
        </span>
      </div>
    </header>

    <div class="binary-summary">
      <div>
        <div class="binary-summary-label">{{ t('Accumulated + active smaller leg') }}</div>
        <div class="binary-summary-value notranslate">{{ binary.sum | points }} PG</div>
        <div class="binary-summary-sub notranslate">
          {{ t('Month accumulated') }} {{ binary.lower | points }} · {{ t('Smaller leg') }} {{ binary.smaller | points }}
        </div>
      </div>
      <div class="binary-timer">
        <div class="binary-timer-top text-uppercase">{{ t('Current') }}</div>
        <div class="binary-midnight-countdown binary-current">
          <div v-for="side in ['left', 'right']" :key="side" class="binary-side w-50 d-flex flex-column align-items-center">
            <div class="binary-midnight-box w-100">
              <div class="d-flex justify-content-center align-items-start">
                <div class="d-flex flex-column align-items-center">
                  <span class="binary-midnight-num notranslate">{{ binary.current[side] | points }}</span>
                  <span class="binary-midnight-label">{{ t('Total') }}</span>
                </div>
                <span class="binary-midnight-num mx-2">/</span>
                <div class="d-flex flex-column align-items-center">
                  <span class="binary-midnight-num notranslate">{{ binary.valid[side] | points }}</span>
                  <span class="binary-midnight-label">{{ t('Used') }}</span>
                </div>
              </div>
            </div>
            <span class="binary-side-label text-white text-uppercase mt-1">{{ side == 'left' ? t('Left') : t('Right') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="binary-grid">
      <article v-for="vertical in verticalList" :key="vertical.key" class="binary-vcard">
        <h6 class="binary-vtitle">
          {{ vertical.title }} <sup>{{ day }}</sup>
          <span class="binary-badge ml-auto" :class="{ 'is-active': vertical.status == 'active' }">
            {{ vertical.status == 'active' ? t('Active') : t('Inactive') }}
          </span>
        </h6>

        <div class="binary-legs">
          <div class="binary-leg" v-for="side in ['left', 'right']" :key="side">
            <div class="binary-leg-name">
              <i class="binary-dot" :class="'is-' + side"></i>{{ side == 'left' ? t('Left') : t('Right') }}
            </div>
            <div class="binary-leg-track">
              <i :class="'is-' + side" :style="{ width: legPercent(vertical.day, side) + '%' }"></i>
            </div>
            <div class="binary-leg-val notranslate">+{{ vertical.day[side] | points }}</div>
          </div>
        </div>
      </article>
    </div>
  </fieldset>
</template>

<style scoped>
.binary-side-label {
  font-size: 11px;
}

/* No mobile cada lado ocupa uma linha */
@media (max-width: 720px) {
  .binary-current {
    flex-direction: column;
  }

  .binary-current .binary-side {
    width: 100% !important;
  }
}

.binary-inactive {
  opacity: 0.6;
}
</style>
